'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Utility for adding event listeners that returns the listener for easy unsubscribing
 *
 *
 * @param {HTMLElement} el
 * @param {string|string[]} types
 * @callback {function} cb
 * @param {boolean=false} capture
 * @param {object=null} context
 * @returns {function()} unsubscribe
 */

exports.default = function (el, types, cb) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;


    var events = typeof types === 'string' ? types.split(' ').map(function (t) {
        return t.trim();
    }) : types;

    var boundCallback = cb.bind(context);
    var subs = events.map(function (type) {

        el.addEventListener(type, boundCallback, capture);
        return type;
    });

    var unsubscribe = function unsubscribe() {

        subs.forEach(function (type) {
            return el.removeEventListener(type, boundCallback, capture);
        });
    };

    return unsubscribe;
};